import type { ReactNode } from 'react';

import { Button } from '../../ui/button';
import { Input } from '../../ui/input';

export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-muted-fg">{label}</span>
      {children}
      {hint && <span className="mt-1 block text-xs text-muted-fg">{hint}</span>}
    </label>
  );
}

export function TextArea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const { className, ...rest } = props;
  return (
    <textarea
      className={`w-full rounded border border-border bg-card p-2 text-sm text-fg placeholder:text-muted-fg ${className ?? ''}`}
      {...rest}
    />
  );
}

/** Editable list of short strings (facts, rules, stop topics). */
export function StringListField({
  label,
  hint,
  placeholder,
  values,
  onChange,
}: {
  label: string;
  hint?: string;
  placeholder?: string;
  values: string[];
  onChange: (next: string[]) => void;
}) {
  return (
    <fieldset className="space-y-1">
      <legend className="mb-1 text-xs font-medium text-muted-fg">{label}</legend>
      {values.map((value, i) => (
        <div key={i} className="flex gap-1">
          <Input
            aria-label={`${label}: строка ${i + 1}`}
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(values.map((v, j) => (j === i ? e.target.value : v)))}
          />
          <Button
            type="button"
            variant="ghost"
            size="sm"
            aria-label={`Удалить из «${label}» строку ${i + 1}`}
            onClick={() => onChange(values.filter((_, j) => j !== i))}
          >
            ✕
          </Button>
        </div>
      ))}
      <Button type="button" variant="secondary" size="sm" onClick={() => onChange([...values, ''])}>
        + {label}
      </Button>
      {hint && <p className="text-xs text-muted-fg">{hint}</p>}
    </fieldset>
  );
}
